<template>
  <div class="home-view">
    <router-view/>
    <DisclaimerMessage/>
  </div>
</template>

<script setup>
import AOS from "aos";
import "aos/dist/aos.css";
import { SENTRY_PROID, SENTRY_PROKEY } from "./config";
import DisclaimerMessage from "./components/Disclaimer/DisclaimerMessage.vue";

import { onBeforeMount, onMounted } from 'vue';

const sentryData = {
  product: 'doo-group',
  proKey: SENTRY_PROKEY,
  proId: SENTRY_PROID,
};

function loadSentryScript() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'sentry-health-track';
  script.src = '/healthCheck.js';
  script.setAttribute('data-track-config', JSON.stringify(sentryData));
  document.body.appendChild(script);
}

onBeforeMount(() => {
  loadSentryScript();
});

onMounted(() => {
  AOS.init();
});
</script>

<style>
.home-view{
  position: relative;
}
</style>

